
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M11.103 8.228a1 1 0 011.794 0l.615 1.249a1 1 0 00.753.547l1.378.2a1 1 0 01.554 1.705l-.997.973a1 1 0 00-.287.885l.235 1.371a1 1 0 01-1.45 1.054l-1.233-.647a1 1 0 00-.93 0l-1.232.647a1 1 0 01-1.451-1.054l.235-1.371a1 1 0 00-.287-.885l-.997-.973a1 1 0 01.554-1.705l1.377-.2a1 1 0 00.753-.547l.616-1.249z","stroke":"#CACACA","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"9.004","stroke":"#CACACA","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    